// styles
import { chartDashboardBoxStyle } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledPkgCard = styled.div`
  ${chartDashboardBoxStyle}
  padding: 20px;

  > h2 {
    margin-bottom: 12px;
  }
`;

export const StyledChartWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

export const StyledChartCardWrapper = styled.div`
  position: relative;
  padding: 12px 14px;
  width: 326px;
  min-width: 326px;
  height: 229px;
  border-radius: 10px;
  border: 1px solid var(--color-pale-gray);
  background: var(--color-off-white);

  > h3 {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    position: absolute;
    top: 16px;
    left: 17px;
  }
`;

export const StyledChartCardNumber = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: flex-end;

  > p {
    color: var(--color-secondary-blue);
    text-align: right;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    display: inline-block;

    > span {
      color: var(--color-secondary-blue);
      text-align: right;
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      display: inline-block;
    }

    &:last-of-type {
      color: var(--color-secondary-blue);
      text-align: right;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;

      > span {
        color: var(--color-secondary-blue);
        text-align: right;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
      }
    }
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  height: 153px;
  margin-top: 4px;
`;

export const StyledChartBox = styled.div`
  position: relative;
  width: 87px;
  height: 87px;

  > canvas {
    position: relative;
    height: 87px !important;
  }
`;

export const StyledTotalLegend = styled.div`
  position: absolute;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    color: var(--color-black);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const StyledTable = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTableHeader = styled.div`
  display: grid;
  grid-template-columns: 107px 52px 36px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--color-light-gray);
  margin-bottom: 8px;

  &.percentage {
    grid-template-columns: 96px 106px 57px 57px;
  }

  > p {
    text-align: center;
    color: var(--color-light-gray);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;

    &:first-of-type {
      text-align: left;
    }
  }
`;

export const StyledTableRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  max-height: 153px;
  overflow-y: auto;
`;

export const StyledTableRow = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 107px 52px 36px;

  &.percentage {
    grid-template-columns: 96px 106px 57px 57px;

    .title {
      padding-left: 0px;

      &::before {
        display: none;
      }
    }
  }

  .title {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    position: relative;
    padding-left: 6px;

    &::before {
      content: '';
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 12px;
      border-radius: 8px;
    }

    &.samsung::before {
      background-color: #1d3f85;
    }

    &.gs::before {
      background-color: #306cd2;
    }

    &.aic::before {
      background-color: #5fa6f8;
    }

    &.gsil::before {
      background-color: #bc9fe5;
    }

    &.etc::before {
      background-color: #e9dff5;
    }
  }

  .progress {
    position: relative;
    width: 100%;
    height: 12px;
    border-radius: 6px;
    background-color: transparent;
    overflow: hidden;
  }

  .number {
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

export const ProgressBar = styled.div<{ $width: number; $backWidth: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0 6px 6px 0;

  &.samsung::before,
  &.samsung::after {
    background-color: #1d3f85;
  }

  &.gs::before,
  &.gs::after {
    background-color: #306cd2;
  }

  &.aic::before,
  &.aic::after {
    background-color: #5fa6f8;
  }

  &.gsil::before,
  &.gsil::after {
    background-color: #bc9fe5;
  }

  &.etc::before,
  &.etc::after {
    background-color: #e9dff5;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0 6px 6px 0;
    background-color: #1d3f85;
    width: ${(props) => Math.min(Math.max(props.$width, 0), 100)}%;
    height: 100%;
    z-index: 2;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0 6px 6px 0;
    background-color: #1d3f85;
    opacity: 0.5;
    width: ${(props) => Math.min(Math.max(props.$backWidth, 0), 100)}%;
    height: 100%;
    z-index: 1;
  }
`;
